import { createRouter, createWebHistory } from 'vue-router'
import routes from '@/router/routes'
import store from '@/store/index.ts'
import { writeRouteHistory } from 'best-modules/utils'

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.afterEach(writeRouteHistory)

router.beforeEach((to, from, next) => {
  setTimeout(() => {
    document.title = to.meta?.title || 'Система візування'
  }, 0)

  const hasToken = !!store.state.auth.token
  const hasAuthUser = !!store.state.auth.authUser.id
  const hasResource = store.getters['user/canAccessResource']
  const authMode = window.AUTH?.mode ?? 'local'
  const ssoLoginUrl = window.AUTH?.loginUrl
  const isAuthRoute = [
    'login',
    'auth-confirm',
    'forgot-password',
    'sso-login',
  ].includes(to.name)
  const isSsoRoute = to.meta.sso === true

  console.log(from.name, to.name)

  switch (true) {
    case authMode === 'sso' && !hasToken && !!ssoLoginUrl: {
      const loginUrl = new URL(ssoLoginUrl, window.location.origin)
      loginUrl.searchParams.set('intended', to.fullPath)
      window.location.href = loginUrl.href
      break
    }
    case authMode === 'idp' && !hasToken && !isSsoRoute:
      next({ name: 'sso-login' })
      break
    case isSsoRoute:
      next()
      break
    case to.name === 'share-document':
      next()
      break
    case !isAuthRoute && !hasToken:
      next({ name: 'login' })
      break
    case isAuthRoute && hasToken && from.name === 'home':
      next(false)
      break
    case isAuthRoute && hasToken:
      next({ name: 'home' })
      break
    case to.name === 'auth-confirm' && !hasAuthUser:
      next({ name: 'login' })
      break
    default: {
      const user = store.state.user.userData

      if (user) {
        const resource = to.matched
          .map(r => r.meta.resource)
          .filter(Boolean)
          .pop()
        if (resource && !hasResource(resource)) {
          next({ name: 'home' })
          return
        }
      }

      next()
    }
  }
})

export default router
